module.exports = __webpack_public_path__ + "b1966b96ab5901132a314e8c86f4b650.svg";